<template>
    <ResizeScale>
        <template slot="slot">
            <section id="join-section" class="layout layout-scale layout-scale-join-page">
                <div class="header text-center" style="min-height: 122px">
                    <HeaderLogo
                        logoWidth="22"
                        class="logo"
                        :shadow="$route.query.code ? 'var(--question-shadow-color)' : 'var(--text-shadow-color)'"
                        color="var(--ui-color)"
                    >
                    </HeaderLogo>
                </div>
                <div class="content overflow-x-hidden flex justify-center items-center">
                    <div class="wrapper max-w-lg w-full content-container">
                        <div v-if="!isLoggedIn()">
                            <h1
                                class="text-center text-white mb-5 sm:mb-4 mt-0 font-size-38"
                                style="color: var(--ui-color) !important"
                            >
                                {{ $t('auth_login_button_register') }}
                            </h1>
                            <h1
                                class="text-center text-white mb-5 sm:mb-4 mt-0 font-size-30"
                                style="color: var(--ui-color) !important"
                            >
                                {{ titleName }}
                            </h1>
                            <div class="text-center text-white mb-5 sm:mb-4 mt-0 uppercase font-size-38">
                                <input
                                    name="name"
                                    v-model="form.name"
                                    class="input-school input-block input-text-center font-size-16 md:font-size-22"
                                    type="text"
                                    placeholder="Name"
                                />
                            </div>
                            <div class="text-center text-white mb-5 sm:mb-4 mt-0 uppercase font-size-38">
                                <input
                                    name="email"
                                    v-model="form.email"
                                    class="input-school input-block input-text-center font-size-16 md:font-size-22"
                                    type="email"
                                    placeholder="E-mail"
                                />
                            </div>
                            <div v-if="devMode" class="text-center text-white mb-5 sm:mb-4 mt-0 uppercase font-size-38">
                                <input
                                    name="Password"
                                    v-model="form.password"
                                    class="input-school input-block input-text-center font-size-16 md:font-size-22"
                                    type="password"
                                    placeholder="Password"
                                />
                            </div>
                            <div
                                class="w-3/5 flex flex-col sm:flex-row sm:w-full sm:items-center sm:justify-center mt-5 mb-8"
                            >
                                <div class="flex md:flex-wrap sm:mb-0 w-full">
                                    <div class="sm:w-1/2 flex sm:justify-end">
                                        <div class="pr-4 sm:pr-2 otp-radio">
                                            <x-checkbox
                                                id="otp-radio"
                                                type="radio"
                                                class="mr-1 shadow-text-none font-size-18 text-white"
                                                size="lg"
                                                name="select-auth"
                                                :checked="true"
                                                @input="() => (form.auth_select = 'otp')"
                                            >
                                                <span style="color: var(--ui-color) !important">{{
                                                    $t('auth_login_with_otp')
                                                }}</span>
                                            </x-checkbox>
                                        </div>
                                    </div>

                                    <div class="sm:w-1/2">
                                        <div class="pl-4 sm:pl-2 auth-radio">
                                            <x-checkbox
                                                id="auth-radio"
                                                type="radio"
                                                class="mr-1 shadow-text-none font-size-18 text-white"
                                                size="lg"
                                                name="select-auth"
                                                @input="() => (form.auth_select = 'google-auth')"
                                            >
                                                <span style="color: var(--ui-color) !important">{{
                                                    $t('auth_login_with_2fa')
                                                }}</span>
                                            </x-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center text-white mb-5 sm:mb-4 mt-0 uppercase font-size-38">
                                <button
                                    :disabled="
                                        devMode
                                            ? !form.name.trim() || !form.email.trim() || !form.password.trim()
                                            : !form.name.trim() || !form.email.trim()
                                    "
                                    @click="registerSchool"
                                    class="btn btn-large font-opensans font-size-22"
                                >
                                    {{ $t('auth_login_button_register') }}
                                </button>
                            </div>
                        </div>
                        <div v-else>
                            <h1
                                class="text-center text-white mb-5 sm:mb-4 mt-0 font-size-38"
                                style="color: var(--ui-color) !important"
                            >
                                {{ $t('school_login_show_text_title', { titleName }) }}
                            </h1>
                            <p
                                id="text-school-description"
                                class="text-center text-white mb-5 sm:mb-4 mt-0 font-size-24 normal"
                                style="white-space: pre-line"
                            >
                                <span class="text-school-description" v-html="schoolDescription"></span>
                            </p>
                            <div class="text-center mt-10">
                                <a
                                    @click="openNewQuizPopup"
                                    class="btn md:w-full block md:inline btn-lg text-xl font-opensans mb-1"
                                >
                                    <i class="fas fa-plus mr-2"></i>
                                    {{ $t('school_new_quiz') }}
                                </a>
                                <router-link
                                    :to="{ name: 'my-quiz', query: { type: 'school' } }"
                                    class="md:w-full block md:inline ml-0 md:ml-2 btn btn-lg text-xl font-opensans mb-1"
                                >
                                    <i class="fas fa-th mr-2"></i>
                                    {{ $t('school_quizes_in_school') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center footer">
                    <a
                        @click.prevent="openWhatIsTbqPopup"
                        style="color: var(--ui-color) !important"
                        href="#"
                        class="text-white no-underline font-size-14"
                    >
                        {{ $t('tbq_what_is_tbq') }}
                    </a>
                </div>
            </section>
            <div>
                <TopRightMenu
                    ref="topRightMenu"
                    :login-status="loginStatus"
                    @click-your-quiz-link="clickToMyQuiz()"
                    @click-new-quiz="clickNewQuiz()"
                    @click-edit-profile="clickEditProfile()"
                    @click-order="clickOrder()"
                    @click-subscribe-plan="clickSubscribePlan()"
                    @click-subpage="clickSubpage"
                    @click-buy-credit="clickBuyCredit()"
                    @open-auth-popup="showAuthPopup = true"
                />

                <AuthPopup
                    v-if="showAuthPopup"
                    ref="authPopup"
                    :webview-redirect-to="createWebviewRedirectTo()"
                    :login-title="[$t('top_right_menu_login')]"
                    :prevent-newsletter-popup="true"
                    @login-success="loginSuccess"
                    @register-success="registerSuccess"
                    @close="showAuthPopup = false"
                />
            </div>
            <one-time-auth-modal
                v-if="showOneTimeModal"
                ref="oneTimeAuth"
                @close="showOneTimeModal = false"
                @confirm="onConfirm"
            ></one-time-auth-modal>
        </template>
    </ResizeScale>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import ResizeScale from '@/components/ResizeScale.vue'
import AuthPopup from '@/components/AuthPopup'
import TopRightMenu from '@/components/TopRightMenu'
import AuthPopupMixin from '@/mixins/auth-popup'
import { load } from 'recaptcha-v3'
import Request from '@/lib/request.js'
import appConfig from '@/app.config'
import popup from '@/lib/popup.js'
import helperMixins from '@/mixins/helper.js'
import UserService from '@/lib/user.js'
import { currentUser } from '@/lib/user'
import XCheckbox from '@/components/v2/XCheckbox'
import OneTimeAuthModal from '@/components/OneTimeAuthModal'

export default {
    mixins: [AuthPopupMixin, helperMixins],

    components: {
        HeaderLogo,
        ResizeScale,
        AuthPopup,
        TopRightMenu,
        XCheckbox,
        OneTimeAuthModal
    },

    data: function () {
        return {
            title: '',
            form: {
                name: '',
                email: '',
                password: '',
                auth_select: 'otp'
            },
            isSchool: true,
            isLoading: false,
            isSlug: false,
            titleName: '',
            schoolDescription: '',
            slug: '',
            showOneTimeModal: false
        }
    },

    mounted: function () {
        this.title = this.$route.params.slug
        this.slug = this.$route.params.slug
        this.getSlug(this.title)
        this.getUserBySlug()

        if (currentUser()) {
            if (!currentUser().role.includes('teacher') && !currentUser().role.includes('student')) {
                this.$router.replace({
                    name: 'school-my-quizzes',
                    params: { slug: this.slug }
                })
            }
        }
    },

    methods: {
        registerSchool() {
            this.$store.commit('toggleMainLoader', true)
            load(this.getRecaptchaSiteKey(), {
                useRecaptchaNet: true,
                autoHideBadge: true
            }).then(async recaptcha => {
                this.form.captcha_response = await recaptcha.execute('validate_captcha', { action: 'validate_captcha' })
                this.$validator.validate().then(result => {
                    if (!result) {
                        this.$emit('validate-fail')
                        return false
                    }

                    const request = new Request()
                    this.form.schoolSlug = this.title

                    let url = this.devMode ? appConfig.api.registerSchool : appConfig.api.checkSchoolOneTime

                    request
                        .post(url, this.form)
                        .then(res => {
                            if (this.devMode) {
                                const userService = new UserService()
                                userService.setToken(res.data.token)
                                this.$emit('register-success', userService.getUser())
                                this.$store.commit('toggleMainLoader', false)

                                window.location.reload()
                                this.isSchool = false
                                this.isLoading = false
                            } else {
                                this.form.is_google2fa = res.data.data.auth_select == 'otp' ? false : true
                                this.form.key_google2fa = res.data.data.key_google2fa
                                this.form.qrcode_image = res.data.data.qrcode_image

                                this.showOneTimeModal = true
                                this.$nextTick(() => {
                                    this.$refs.oneTimeAuth.onShow(this.form)
                                })
                            }
                        })
                        .catch(err => {
                            var res = err.response.data.data
                            this.$store.commit('toggleMainLoader', false)

                            if (res.email) {
                                popup.alert(this.$t('auth_alert_already_email'))
                            } else {
                                popup.alert(this.translate('auth_email_not_allows'))
                            }
                            this.isLoading = false
                        })
                })
            })
        },

        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        getSlug(slug) {
            const request = new Request()

            request
                .get(appConfig.api.getSlug, { params: { slug: slug } })
                .then(res => {
                    this.schoolDescription = res.data.data.description
                    this.titleName = res.data.data.name
                })
                .catch(() => {
                    this.$router.replace({
                        name: 'index'
                    })
                })
        },

        getUserBySlug() {
            const userId = currentUser().id
            const request = new Request()

            if (typeof userId != 'undefined') {
                request
                    .get(appConfig.api.getSchool.replace('__id__', userId))
                    .then(res => {
                        if (this.slug != res.data.data.register_slug) {
                            this.$router.replace({
                                name: 'school-my-quizzes',
                                params: {
                                    slug: this.slug
                                }
                            })

                            return
                        }

                        setTimeout(() => {
                            this.isSlug = true
                        }, 500)
                    })
                    .catch(() => {
                        this.$router.replace({
                            name: 'index'
                        })
                    })
            }
        },

        onConfirm(data) {
            this.$refs.oneTimeAuth.showLoader(true)

            this.$validator.validate().then(async result => {
                const otpInputs = document.querySelectorAll('.otp-input')
                let inputErr = 0

                const recaptcha = await load(this.getRecaptchaSiteKey(), {
                    useRecaptchaNet: true,
                    autoHideBadge: true
                })

                const token = await recaptcha.execute('validate_captcha', {
                    action: 'validate_captcha'
                })

                otpInputs.forEach(e => {
                    if (!e.value) {
                        inputErr += 1
                    }
                })

                if (!result || inputErr) {
                    return false
                }

                let form = {
                    login_token: data.login_token,
                    otp: data.otp,
                    otp_ref: data.otp_ref,
                    email: data.email,
                    auth_select: data.auth_select,
                    name: data.name,
                    key_google2fa: data.key_google2fa,
                    role: data.role,
                    captcha_response: token,
                    schoolSlug: data.schoolSlug
                }

                const request = new Request()

                await request
                    .post(appConfig.api.registerOneTime, form)
                    .then(res => {
                        const userService = new UserService()
                        userService.setToken(res.data.token)
                        this.$emit('register-success', userService.getUser())
                        this.$store.commit('toggleMainLoader', false)

                        window.location.reload()
                        this.isSchool = false
                        this.isLoading = false
                    })
                    .catch(() => {
                        this.isLoading = false
                        this.$refs.oneTimeAuth.showLoader(false)
                        this.handleClearInput()
                        return popup.alert(this.translate('auth_login_alert_not_match'))
                    })
            })
        },

        loginSuccess() {
            this.$router.replace({
                name: 'my-quiz'
            })
        },

        registerSuccess() {
            this.$router.replace({
                name: 'my-quiz',
                query: {
                    newsletter: 1
                }
            })
        },

        openNewQuizPopup() {
            window.location.href = this.$router.resolve({
                name: 'my-quiz',
                query: { create: true, type: 'normal' }
            }).href
        },

        openWhatIsTbqPopup() {
            this.$refs.topRightMenu.togglePageSlidePopup('what-is-thebigquiz')
        }
    }
}
</script>

<style lang="scss">
.input-school {
    border: 1px solid var(--ui-color);
    padding: 0.8rem;
    background-color: rgba(255, 255, 255, 0.7);
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
}

.otp-radio label .check-box.big.light {
    border: 3px solid var(--ui-color);
}

.auth-radio label .check-box.big.light {
    border: 3px solid var(--ui-color);
}

.select-auth-box {
    column-gap: 16px;
}

#text-school-description {
    color: var(--ui-color) !important;
}

.text-school-description {
    a {
        color: var(--ui-color) !important;
    }
}

@media (max-height: 735px) {
    .content {
        overflow-x: hidden !important;
        overflow-y: auto !important;
    }
}

@media (max-width: 575px) {
    .logo {
        width: 12rem;
        max-width: 8.75rem !important;
    }
}
</style>
